import { TypedForm, ObjectSchema, object, date, array } from 'libs/form';

export interface ProductionCalendarFormType {
  weekendsDate?: Date[];
}

export const productionCalendarSchema: ObjectSchema<ProductionCalendarFormType> =
  object({
    weekendsDate: array(date().required()).optional(),
  });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<ProductionCalendarFormType>();
